<template>
	<v-card class="elevation-0" >
		<!-- Alumno nuevo -->
  	<v-alert
      border="bottom"
      type="info"
      text
      dark
    >
      Selecciona el prospecto por el cual está ligado el alumno, recuerda que el <b>FOLIO</b> de prospecto se da al momento de darle seguimiento, en dado caso de que no exista un prospecto, se puede generar desde aquí.
    </v-alert>
		<br/>

		<label><b>Aquí podrás revisar los datos de los hermanos agregados</b></label>


	<v-row>
		<v-col cols="12" md="6" lg="3">
			<v-tooltip bottom color="blue" max-width="300">
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
			      v-model="cantidadHermanos"
				    append-outer-icon="mdi-plus-circle"
				    prepend-icon="mdi-minus-circle"
				    filled
				    label="Hermanos"
				    type="text"
				    readonly
				    @click:append-outer="addCantidad"
				    @click:prepend="menosCantidad"
				    v-bind="attrs"
				    v-on="on"
				  ></v-text-field>
				</template>
				<span>Ajusta la cantidad de hermanos que deseas inscribir (mínimo 2)</span>
			</v-tooltip>
		</v-col>
	</v-row>

		<v-card class="shadowCard mb-4" outlined>
			<v-card-title class="py-2 text-body-1">Beca empleado (opcional)</v-card-title>
			<v-card-text>
				<label class="pl-0 black--text">Un folio RH cubre a todos los hermanos. No es el folio del prospecto.</label>
				<v-row>
					<v-col cols="12" md="6">
						<v-text-field
							v-model="folio_rh_familia"
							label="Folio RH"
							placeholder="RH-00001"
							filled
							dense
							hide-details="auto"
							:loading="validandoFolioRh"
							:error-messages="folioRhError"
							@input="onFolioRhInput($event, aplicarFolioRhHermanos)"
						/>
					</v-col>
					<v-col cols="12" md="6" class="d-flex align-center">
						<v-alert
							v-if="folioRhInfo"
							type="success"
							dense
							text
							class="mb-0"
						>
							<b>{{ folioRhInfo.folio_rh }}</b> — {{ folioRhInfo.trabajador }}
							<div class="caption">Beca 100% autorizada para todos los hermanos de este registro.</div>
						</v-alert>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>

		<v-row>
			<v-col cols="12">
				<v-expansion-panels>
					<v-expansion-panel
			      v-for="(item, i ) in hermanos"
			      :key="i"
			      class="elevation-10"
			    >
			      <v-expansion-panel-header>
			        Datos del hermano {{ i + 1 }}
			      </v-expansion-panel-header>
			      <v-expansion-panel-content>
				  	<!-- BUSCAR POR MATRICULA -->
				  	<label class="pl-0 black--text" v-if="i == 0">Prospecto</label>
				  	<div class="text-caption grey--text" v-if="i == 0">Escribe al menos 3 letras (o el folio numérico) para buscar; no se cargan todos los registros.</div>
						<v-row v-if="i == 0">
							<v-col cols="12" class="pt-0">
								<v-tooltip bottom color="blue" max-width="300">
									<template v-slot:activator="{ on, attrs }">
										<v-autocomplete
						          filled 
						          dense
						          clearable
						          no-filter
						          v-model="id_prospecto"
						          :items="itemsProspectosAutocomplete"
						          :loading="loadingProspectos"
						          :search-input.sync="prospectoSearchInput"
						          label="Buscar prospecto"
						          hide-details
						          item-text="datos_completos"
						          item-value="idprospectos"
						          class="mt-4"
						          placeholder="Ej. nombre o folio de prospecto"
						          :no-data-text="textoSinProspectos"
						          @input="onProspectoAutocompleteInput"
						          v-bind="attrs"
						          v-on="on"
						        >
						        </v-autocomplete>
									</template>
									<span>Selecciona el prospecto del cual provienen los hermanos</span>
								</v-tooltip>
							</v-col>
						</v-row>

						<v-tooltip bottom color="blue" max-width="300" v-if="!item.id_prospecto && i == 0">
							<template v-slot:activator="{ on, attrs }">
								<v-btn 
									color="red" 
									dark 
									small 
									class="mt-2 text-capitalize" 
									@click="abrirDialogProspecto()"
									tile
									v-bind="attrs"
									v-on="on"
								>
									No existe el prospecto
								</v-btn>
							</template>
							<span>Crear un nuevo prospecto si no existe en la lista</span>
						</v-tooltip>

							<v-divider class="my-4"></v-divider>

				    <!-- Datos generales del alumno -->
				    <label class="pl-0 black--text" >Datos generales</label>
						<v-row v-if="item.id_prospecto">
							<v-col cols="12" sm="6">
								<v-tooltip bottom color="blue" max-width="300">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
										  filled 
										  dense
										  hide-details
										  v-model="item.nombre"
										  label="Nombre"
										  v-bind="attrs"
										  v-on="on"
										></v-text-field>
									</template>
									<span>Ingresa el nombre del hermano</span>
								</v-tooltip>
							</v-col>

							<v-col cols="12" sm="6">
								<v-tooltip bottom color="blue" max-width="300">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
										  filled 
										  dense
										  hide-details
										  v-model="item.apellido_paterno"
										  label="Ap. Paterno"
										  v-bind="attrs"
										  v-on="on"
										></v-text-field>
									</template>
									<span>Ingresa el apellido paterno del hermano</span>
								</v-tooltip>
							</v-col>

							<v-col cols="12" sm="6">
								<v-tooltip bottom color="blue" max-width="300">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
										  filled 
										  dense
										  hide-details
										  v-model="item.apellido_materno"
										  label="Ap. Materno"
										  v-bind="attrs"
										  v-on="on"
										></v-text-field>
									</template>
									<span>Ingresa el apellido materno del hermano</span>
								</v-tooltip>
							</v-col>

							<v-col cols="12" sm="6">
								<v-tooltip bottom color="blue" max-width="300">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
										  filled 
										  dense
										  hide-details
										  v-model="item.edad"
										  label="Edad"
										  type="number"
										  v-bind="attrs"
										  v-on="on"
										></v-text-field>
									</template>
									<span>Ingresa la edad del hermano</span>
								</v-tooltip>
							</v-col>
						</v-row>

						<!-- Datos del contacto -->
						<v-divider class="my-4"></v-divider>
						<label class="pl-0 black--text" >Datos de contacto</label>
						<v-row v-if="item.id_prospecto">
							<v-col cols="12" sm="6">
								<v-tooltip bottom color="blue" max-width="300">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
										  filled 
										  dense
										  hide-details
										  v-model="item.telefono"
										  label="Teléfono"
										  type="number"
										  v-bind="attrs"
										  v-on="on"
										></v-text-field>
									</template>
									<span>Ingresa el teléfono fijo del hermano o tutor</span>
								</v-tooltip>
							</v-col>

							<v-col cols="12" sm="6">
								<v-tooltip bottom color="blue" max-width="300">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
										  filled 
										  dense
										  hide-details
										  v-model="item.celular"
										  label="Celular"
										  type="number"
										  v-bind="attrs"
										  v-on="on"
										></v-text-field>
									</template>
									<span>Ingresa el número celular del hermano o tutor</span>
								</v-tooltip>
							</v-col>
						</v-row>
			      </v-expansion-panel-content>
			    </v-expansion-panel>
			  </v-expansion-panels>
			</v-col>
		</v-row>

		<v-divider class="my-4"></v-divider>

		<v-card class="elevation-10">
			<v-card-title primary-title class="text-capitalize">
			  Datos del tutor
			</v-card-title>
	  <v-card-text>
	    <label class="pl-0 black--text">Datos generales</label>
			<v-row>
				<v-col cols="12" sm="6">
					<v-tooltip bottom color="blue" max-width="300">
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
							  filled
							  dense
							  hide-details
							  v-model="tutor.nombre"
							  label="Nombre"
							  v-bind="attrs"
							  v-on="on"
							></v-text-field>
						</template>
						<span>Ingresa el nombre del tutor o padre de familia</span>
					</v-tooltip>
				</v-col>

				<v-col cols="12" sm="6">
					<v-tooltip bottom color="blue" max-width="300">
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
							  filled
							  dense
							  hide-details
							  v-model="tutor.apellido_paterno"
							  label="Ap. Paterno"
							  v-bind="attrs"
							  v-on="on"
							></v-text-field>
						</template>
						<span>Ingresa el apellido paterno del tutor</span>
					</v-tooltip>
				</v-col>

				<v-col cols="12" sm="6">
					<v-tooltip bottom color="blue" max-width="300">
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
							  filled
							  dense
							  hide-details
							  v-model="tutor.apellido_materno"
							  label="Ap. Materno"
							  v-bind="attrs"
							  v-on="on"
							></v-text-field>
						</template>
						<span>Ingresa el apellido materno del tutor</span>
					</v-tooltip>
				</v-col>

				<v-col cols="12" sm="6">
					<v-tooltip bottom color="blue" max-width="300">
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
							  filled
							  dense
							  hide-details
							  v-model="tutor.tipo_parentesco"
							  label="Parentezco"
							  v-bind="attrs"
							  v-on="on"
							></v-text-field>
						</template>
						<span>Indica el parentesco con los alumnos (padre, madre, abuelo, tío, etc.)</span>
					</v-tooltip>
				</v-col>
			</v-row>

			<v-divider class="my-4"></v-divider>
			<label class="pl-0 black--text">Datos de contacto</label>
			<v-row>
				<v-col cols="12" sm="6">
					<v-tooltip bottom color="blue" max-width="300">
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
							  filled
							  dense
							  hide-details
							  v-model="tutor.telefono"
							  label="Teléfono"
							  type="number"
							  v-bind="attrs"
							  v-on="on"
							></v-text-field>
						</template>
						<span>Ingresa el teléfono fijo del tutor</span>
					</v-tooltip>
				</v-col>

				<v-col cols="12" sm="6">
					<v-tooltip bottom color="blue" max-width="300">
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
							  filled
							  dense
							  hide-details
							  v-model="tutor.celular"
							  label="Celular"
							  type="number"
							  v-bind="attrs"
							  v-on="on"
							></v-text-field>
						</template>
						<span>Ingresa el número celular del tutor</span>
					</v-tooltip>
				</v-col>
			</v-row>
	  </v-card-text>
		</v-card>

		<v-card-actions>
      <v-tooltip bottom color="blue" max-width="300">
        <template v-slot:activator="{ on, attrs }">
          <v-btn text @click="dialogAddAlumno.estatus = false" v-bind="attrs" v-on="on">
            Cancelar
          </v-btn>
        </template>
        <span>Cerrar y cancelar el proceso de inscripción</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-tooltip bottom color="blue" max-width="300">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            @click="steppers.paso = 2"
            v-bind="attrs"
            v-on="on"
          >
            Continuar
          </v-btn>
        </template>
        <span>Continuar al siguiente paso para seleccionar grupo</span>
      </v-tooltip>
  	</v-card-actions>


  	<!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

    <AgregarProspecto     v-if="existeProspecto"             :parametrosProspectos="parametrosProspectos" @saveProspecto="saveProspecto"/>


	</v-card>
</template>
<script>
import axios from 'axios';
	import { mapGetters, mapActions } from 'vuex'
  import Alerta          from '@/components/alertas/Alerta.vue'
  import carga           from '@/components/alertas/carga.vue';

  import AgregarProspecto   from '@/components/inscripciones/AgregarProspecto.vue';


  import validarErrores  from '@/mixins/validarErrores'
  import folioRhBecaEmpleado from '@/mixins/folioRhBecaEmpleado'

	// Componentes
  export default {
  	components:{
      Alerta,
      carga,
      AgregarProspecto
    },

    mixins: [ validarErrores, folioRhBecaEmpleado ],

  	props:[
			'grupo',
			'alumno',
			'steppers',
			'hermanos',
			'tutor',
			'dialogAddAlumno'
	  ],

    data: () => ({
    	escuela: 2,
			// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      cantidadHermanos: 2,

      respuestaAlerta:false,
      cargar: false,

			step:1,
			isTutor:true,

			opcion:1,

			posicionHermano: 0,

			empleados:[],
			sonHermanos:false,
			alumnoNuevo:{
				id_hermano: 0,
				nombre:'',
		    apellido_paterno:'',
		    apellido_materno:'',
		    telefono:'',
		    celular:'',
		    id_tipo_alumno:'1',
		    id_usuario_ultimo_cambio:'0',
		    matricula:'',
		    edad:'',
		    ocupacion:'Estudiante',
		    id_contacto:0,
		    unidad_negocio:0,
		    id_prospecto:null,
		    id_empleado: null,
		    folio_rh: null,
		    tutor: null,
		    matricula_erp:'',
		    iderp:0,
			},

			existeMatricula: false,
    	prospectosBusqueda: [],
    	prospectoElegido: null,
    	prospectoSearchInput: '',
    	loadingProspectos: false,
    	_debounceProspectos: null,
    	parametrosProspectos:{
    		estatus: false
    	},
    	existeProspecto:false,
    	prospecto: null,
    	prospectoSeleccionado: null,

    	alertaSeguridad: false,

    	headers:[
    		{ text: 'Nombre'       , value: 'nombre'       },
        { text: 'Telefono'     , value: 'telefono'     },
        { text: 'Grupo'        , value: 'grupo'        },
        { text: 'ID prospecto' , value: 'id_prospecto' },
    	],

    	id_prospecto: null,
    	folio_rh_familia: '',



    }),

    computed: {
    	...mapGetters('login',['getdatosUsuarioERPERP', 'getEscuela']),
    	itemsProspectosAutocomplete() {
    		const idSel = this.id_prospecto
    		const list = [...this.prospectosBusqueda]
    		if (this.prospectoElegido && this.prospectoElegido.idprospectos === idSel &&
    		    !list.some(p => p.idprospectos === idSel)) {
    			list.unshift(this.prospectoElegido)
    		}
    		return list
    	},
    	textoSinProspectos() {
    		if (this.esFolioRhTexto(this.prospectoSearchInput)) {
    			return 'Eso es un folio RH, no de prospecto. Úsalo en Folio RH (arriba).'
    		}
    		return 'No hay datos disponibles'
    	},
    },

    watch:{
    	prospectoSeleccionado( value){
    		if( value ){
    			this.alumnoNuevo.folio        = value.matricula
    			this.alumnoNuevo.nombre       = value.alumno
    			this.alumnoNuevo.telefono     = value.telefono
    			this.alumnoNuevo.celular      = value.telefono
    			this.alumnoNuevo.id_contacto  = value.idprospectos
    			this.alumnoNuevo.id_prospecto = value.idprospectos
    		}
    	},


    	id_prospecto( value ){
    		for( const i in this.hermanos ){
	    		this.hermanos[i].id_prospecto = value
	    	}
    	},

    	alumno( ){
  			this.alumnoNuevo = Object.assign({}, this.alumnoVacio)
  			this.tutor       = Object.assign({}, this.tutorVacio)
  			this.prospectoElegido = null
  			this.prospectosBusqueda = []
  			this.prospectoSearchInput = ''

  			if( this.alumno && this.alumno.idprospectos ){
    			this.alumnoNuevo.nombre                   = this.alumno.alumno
		    	this.alumnoNuevo.apellido_paterno         = ''
		    	this.alumnoNuevo.apellido_materno         = ''
		    	this.alumnoNuevo.telefono                 = this.alumno.telefono
		    	this.alumnoNuevo.celular                  = this.alumno.telefono
		    	this.alumnoNuevo.id_tipo_alumno           = 1
		    	this.alumnoNuevo.id_usuario_ultimo_cambio = this.getdatosUsuarioERPERP.iderp
		    	this.alumnoNuevo.unidad_negocio           = this.getEscuela
		    	this.alumnoNuevo.id_prospecto             = this.alumno.idprospectos
		    	this.id_prospecto                        = this.alumno.idprospectos
    		} else {
    			this.id_prospecto = null
    		}
    	},

    	prospectoSearchInput(val) {
    		if (this.esFolioRhTexto(val)) {
    			this.prospectosBusqueda = []
    			this.loadingProspectos = false
    			if (this.esFolioRhCompleto(val)) {
    				this.folio_rh_familia = this.normalizarFolioRh(val)
    				this.onFolioRhInput(this.folio_rh_familia, this.aplicarFolioRhHermanos)
    			}
    			return
    		}
    		if (this._debounceProspectos) clearTimeout(this._debounceProspectos)
    		this._debounceProspectos = setTimeout(() => {
    			this.buscarProspectosRemoto(val)
    		}, 400)
    	},
    },

    beforeDestroy() {
    	if (this._debounceProspectos) clearTimeout(this._debounceProspectos)
    },

    created () {
    	this.hermanos
    	this.escuela = this.getEscuela

    	while( this.hermanos.length > 0  ){
    		this.hermanos.pop()
    	}

    	for( let i = 0 ; i < this.cantidadHermanos; i++  ){
	    	// Siempre debe empezar en 2!
	    	this.hermanos.push({
					nombre:'',
			    apellido_paterno:'',
			    apellido_materno:'',
			    telefono:'',
			    celular:'',
			    id_tipo_alumno:'1',
			    id_usuario_ultimo_cambio:this.getdatosUsuarioERPERP.iderp,
			    matricula:'',
			    edad:'',
			    ocupacion:'Estudiante',
			    id_contacto:0,
			    unidad_negocio:this.getEscuela,
			    id_prospecto:null,
			    id_empleado: null,
			    folio_rh: null,
			    tutor: null,
			    matricula_erp:'',
			    iderp:0,
			    grupo: null,
			    email: null,
			    celular_whatsapp: '',
				})
    	}

    },

    methods: {

    	addCantidad () {
        this.cantidadHermanos += 1
        this.hermanos.push({
					nombre:'',
			    apellido_paterno:'',
			    apellido_materno:'',
			    telefono:'',
			    celular:'',
			    id_tipo_alumno:'1',
			    id_usuario_ultimo_cambio:this.getdatosUsuarioERPERP.iderp,
			    matricula:'',
			    edad:'',
			    ocupacion:'Estudiante',
			    id_contacto:0,
			    unidad_negocio:this.getEscuela,
			    id_prospecto:null,
			    id_empleado: (this.folioRhInfo && this.folioRhInfo.id_usuario) || null,
			    folio_rh: this.folio_rh_familia || null,
			    tutor: null,
			    matricula_erp:'',
			    iderp:0,
		    	grupo: null,
				})
      },

      menosCantidad () {
        if( this.cantidadHermanos > 2){ 
        	this.cantidadHermanos -= 1 
        	this.hermanos.pop()
        }
      },

      aplicarFolioRhHermanos (info) {
        this.folio_rh_familia = info.folio_rh
        for (const i in this.hermanos) {
          this.hermanos[i].folio_rh = info.folio_rh
          if (info.id_usuario) {
            this.hermanos[i].id_empleado = info.id_usuario
          }
        }
      },

    	debeBuscarProspectos(q) {
    		const t = (q || '').trim()
    		if (!t) return false
    		if (/^\d+$/.test(t)) return t.length >= 1
    		return t.length >= 3
    	},

    	buscarProspectosRemoto(q) {
    		const termino = (q || '').trim()
    		if (this.esFolioRhTexto(termino) || !this.debeBuscarProspectos(termino)) {
    			this.prospectosBusqueda = []
    			this.loadingProspectos = false
    			return
    		}
    		this.loadingProspectos = true
    		const params = {
    			buscar: termino,
    			limit: 50,
    			escuela: this.getEscuela,
    		}
    		return this.$http.get('inscripciones.prospectos.busqueda', { params }).then(response => {
    			const data = response.data
    			this.prospectosBusqueda = Array.isArray(data) ? data : []
    		}).catch(error => {
    			this.validarError(error.response && error.response.data ? error.response.data.message : 'Error al buscar prospectos')
    			this.prospectosBusqueda = []
    		}).finally(() => {
    			this.loadingProspectos = false
    		})
    	},

    	aplicarProspectoSeleccion(item) {
    		if (!item) return
    		this.alumnoNuevo.folio = item.matricula
    		this.alumnoNuevo.nombre = item.alumno
    		this.alumnoNuevo.telefono = item.telefono
    		this.alumnoNuevo.celular = item.telefono
    		this.alumnoNuevo.id_contacto = item.idprospectos
    		this.alumnoNuevo.id_prospecto = item.idprospectos
    	},

    	onProspectoAutocompleteInput(id) {
    		if (!id) {
    			this.prospectoElegido = null
    			return
    		}
    		const item = this.itemsProspectosAutocomplete.find(p => p.idprospectos === id)
    		if (item) {
    			this.prospectoElegido = { ...item }
    			this.aplicarProspectoSeleccion(item)
    		}
    	},

      grabarDatos( ) {
      	this.cargar = true

      	if( !this.sonHermanos ){
	      	this.alumnoNuevo.tutor                    = this.isTutor ? this.tutor : null
	      	this.alumnoNuevo.unidad_negocio           = this.getEscuela
	      	this.alumnoNuevo.id_usuario_ultimo_cambio = this.getdatosUsuarioERPERP.iderp

	        return this.$http.post('alumnos.add', this.alumnoNuevo).then(response=>{
	        	this.alumnoNuevo = this.alumnoVacio
	        	this.tutor       = this.tutorVacio
	        	this.step        = 1
	        	this.$emit('retornarAlumno', response.data )
	        	this.validarSuccess('Alumno registrado correctamente')
	        	this.cargar = false
	        }).catch( error =>{
	          this.validarError( error.response.data.message )
	        }).finally( () => { this.cargar = false })
      	}else{
      		for( const i in this.hermanos ){
      			this.hermanos[i].unidad_negocio           = this.getEscuela
      			this.hermanos[i].id_usuario_ultimo_cambio = this.getdatosUsuarioERPERP.iderp
      		}
      		const payload = {
      			hermanos: this.hermanos,
      			tutor:    this.tutor
      		}

	        return this.$http.post('alumnos.add.hermanos', payload).then(response=>{
	        	this.alumnoNuevo = this.alumnoVacio
	        	this.tutor       = this.tutorVacio
	        	this.step        = 1
	        	let objectHermanos  = Object.assign({}, this.alumnoVacio)
	        	let arrayHermanos   = [objectHermanos]
	        	this.hermanos       = arrayHermanos
	        	this.$emit('retornarAlumno', response.data[0] )
	        	this.validarSuccess('Alumno registrado correctamente')
	        	this.cargar = false
	        }).catch( error =>{
	          this.validarError( error.response.data.message )
	        }).finally( () => { this.cargar = false })
      	}
      },

      abrirDialogProspecto( ){
      	this.existeProspecto              = true
      	this.parametrosProspectos.estatus = true
      },

      saveProspecto( value ){
        this.alumnoNuevo.nombre                   = value.nombre_completo
	    	this.alumnoNuevo.apellido_paterno         = ''
	    	this.alumnoNuevo.apellido_materno         = ''
	    	this.alumnoNuevo.telefono                 = value.telefono
	    	this.alumnoNuevo.celular                  = value.telefono
	    	this.alumnoNuevo.id_tipo_alumno           = 1
	    	this.alumnoNuevo.id_usuario_ultimo_cambio = this.getdatosUsuarioERPERP.iderp
	    	this.alumnoNuevo.unidad_negocio           = this.getEscuela
	    	this.alumnoNuevo.id_prospecto             = value.idprospectos
	    	this.existeMatricula                      = true

	    	for( const i in this.hermanos ){
	    		this.hermanos[i]['id_prospecto'] = value.idprospectos
	    	}

	    	this.id_prospecto = value.idprospectos
	    	const item = {
	    		...value,
	    		idprospectos: value.idprospectos,
	    		datos_completos: value.datos_completos || value.nombre_completo || '',
	    		alumno: value.alumno || value.nombre_completo,
	    		matricula: value.matricula,
	    		telefono: value.telefono,
	    	}
	    	this.prospectoElegido = item
	    	this.prospectosBusqueda = [item]
	    	this.prospectoSearchInput = item.datos_completos

      },
    },
  }
</script>
